import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import categoryApi from 'src/api/categoryApi';
import { LoadingStatus } from '../../enums/enum';
import { ICategory } from '../../interfaces/product.interface';

export const getAllCategories = createAsyncThunk(
  'categories/getAll',
  async () => {
    const response = await categoryApi.getAll();
    if (!response.success)
      throw { message: response.message, errorCode: response.errorCode };
    return response.data;
  }
);

export const createCategory = createAsyncThunk(
  'categories/create',
  async (input: Omit<ICategory, 'id'>) => {
    const response = await categoryApi.create(input);
    if (!response.success)
      throw { message: response.message, errorCode: response.errorCode };
    return response.data;
  }
);

export const updateCategory = createAsyncThunk(
  'categories/update',
  async (input: ICategory) => {
    const { id, ...rest } = input;
    const response = await categoryApi.update(id, rest);
    if (!response.success)
      throw { message: response.message, errorCode: response.errorCode };
    return response.data;
  }
);

export const deleteCategory = createAsyncThunk(
  'categories/delete',
  async (id: number) => {
    const response = await categoryApi.delete(id);
    if (!response.success)
      throw { message: response.message, errorCode: response.errorCode };
    return response.data;
  }
);

export interface CategoryState {
  categories: ICategory[];
  loading: LoadingStatus;
}

const initialState: CategoryState = {
  categories: [],
  loading: LoadingStatus.Pending
};

const categorySlice = createSlice({
  name: 'categories',
  initialState,
  reducers: {},
  extraReducers(builder) {
    builder
      .addCase(getAllCategories.pending, (state) => {
        state.loading = LoadingStatus.Pending;
      })
      .addCase(getAllCategories.fulfilled, (state, action) => {
        state.categories = action.payload ?? [];
        state.loading = LoadingStatus.Fulfilled;
      })
      .addCase(getAllCategories.rejected, (state) => {
        state.loading = LoadingStatus.Rejected;
      });
  }
});
export default categorySlice.reducer;
